import styled from 'styled-components';
import {
  layout,
  LayoutProps,
  TypographyProps,
  typography,
  color,
  ColorProps,
  compose,
  background,
  BackgroundProps,
  space,
  SpaceProps,
  border,
  BorderProps,
} from 'styled-system';

interface TableSubComponents {
  THeader?: any;
  Th?: any;
  Tr?: any;
  TBody?: any;
  Td?: any;
}

type TableProps = TypographyProps & ColorProps & BackgroundProps;

const TableStyle = styled.table<TableProps>(compose(color, typography, background));

const Table: TableSubComponents & typeof TableStyle = TableStyle;

Table.THeader = styled.thead<LayoutProps | ColorProps>(compose(layout, color));
Table.TBody = styled.tbody({});
Table.Tr = styled.tr({});
Table.Th = styled.th<SpaceProps | LayoutProps | ColorProps | TypographyProps>(compose(layout, space, color, typography));
Table.Td = styled.td<SpaceProps | LayoutProps | TypographyProps | ColorProps | BorderProps>(
  compose(layout, space, color, border, typography)
);
Table.Th.defaultProps = {
  paddingX: 2,
  paddingY: [1, 2, 3],
  bg: 'secondary.1',
  color: 'white',
  textAlign: 'center',
  fontSize: [0, null, 1],
};

Table.Td.defaultProps = {
  bg: 'white',
  color: 'secondary.1',
  padding: ['5px', null, '12px'],
  textAlign: 'center',
  borderBottom: '1px solid',
  borderColor: 'secondary.1',
  fontSize: [0, null, 'inherit'],
};
export default Table;
